import { Grid } from '@ltvco/refresh-lib/theme';
import { NeedAssistanceSidebar } from '@ltvco/refresh-lib/v1';
import { Footer } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';

import { constants } from 'appConstants';
import { Billing } from 'routes';

import { ChatPageContainerStack } from '..';

import type { FooterProps } from '../ChatBVContainer';

interface AccountPageProps {
  footerProps: FooterProps;
  onCancelConfirmCancelModal: () => void;
  openConfirmCancelModal: () => void;
  onLogout: () => void;
  contactUsHandler: () => void;
}

export const AccountPage = ({
  footerProps,
  onCancelConfirmCancelModal,
  openConfirmCancelModal,
  onLogout,
  contactUsHandler,
}: AccountPageProps) => {
  const isOnChatBVFlowFooterVariation = useFeatureIsOn('prop-3640');
  const {
    footerLinks,
    libVersion,
    hasMobileApps,
    userInReactivationRedesignTest,
  } = footerProps;
  return (
    <ChatPageContainerStack>
      <Grid
        container
        spacing={{ xs: 2, md: 4, lg: 6 }}
        padding={2}
        width="100%"
      >
        <Grid size={{ xs: 12, md: 8, lg: 9 }}>
          <Billing
            onCancelConfirmCancelModal={onCancelConfirmCancelModal}
            optoutCtaCards={true}
            link={'/chatbv/upgrade/plan'}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4, lg: 3 }} maxWidth={{ md: '275px' }}>
          <NeedAssistanceSidebar
            logout={onLogout}
            supportImgUrl={constants.images.img24hr}
            contactUsHandler={contactUsHandler}
            openConfirmCancelModal={openConfirmCancelModal}
          />
        </Grid>
      </Grid>
      {!isOnChatBVFlowFooterVariation && (
        <Footer
          footerLinks={footerLinks}
          libVersion={libVersion}
          hasMobileApps={hasMobileApps}
          userInReactivationRedesignTest={userInReactivationRedesignTest}
        />
      )}
    </ChatPageContainerStack>
  );
};
